import DeviceDetector from 'device-detector-js';
import { Identifier } from '../models/storage.model';

//TODO move models to separate files
export interface Login {
  username: string;
  password: string;
}

export interface UserLoginDto {
  userName: string;
  password: string;
  userAgent: string;
  platform: string;
}

export interface UserMetaData {
  userAgent: string;
  platform: string;
}

export interface AuthResult {
  token: string;
  expires: string;
  userId: number;
  entityId: number;
  sysEntityTypeId: number;
  securityRoleIds: number[];
  visibleMenuIds: number[];
  enabledActionsIds: number[];
  securityLevel: number;
}

export interface User {
  email: string;
  fullName: string;
  // role: string[];
  // permissions: string[];
  entityId: number;
  sysEntityTypeId: number;
  photoFileUri?: string;
  userId: number;
  nameid?: number;
  unique_name?: string;
}

export function getAccessToken(): string | null {
  return localStorage.getItem(Identifier.TYPE_TOKEN);
}

export function getUserMetaData(): UserMetaData {
  const deviceDetector = new DeviceDetector();
  const navigatorUserAgent = window.navigator.userAgent.toLowerCase();
  const device = deviceDetector.parse(navigatorUserAgent);

  const userAgent = (device?.client?.name || '') + ' ' + (device?.client?.version || '');
  const platform =
    (device?.os?.name || '') +
    ' ' +
    (device?.os?.version || '') +
    ' ' +
    (device?.os?.platform || '');

  return {
    userAgent,
    platform,
  };
}

export function newLoginDto(login: Login): UserLoginDto {
  const metaData = getUserMetaData();
  return {
    userName: login.username,
    password: login.password,
    userAgent: metaData.userAgent,
    platform: metaData.platform,
  };
}
